export default __webpack_public_path__ + "static/media/infinisource-logo.23115b48.png";